export default __webpack_public_path__ + "static/media/company-dashboard.1fc00b67.svg";